import * as React from 'react';

const CurrentSaleInjector = (props) => {
  const { sales, saleId, component, ...rest } = props;

  const Component = component;

  return (
    <Component
      saleId={saleId}
      {...rest}
    />
  );
};

export default CurrentSaleInjector;
